var exports = {
  "zr": "xa15a2ab7--4734a9--root",
  "nM": "xa15a2ab7--4734a9--row",
  "q9": "xa15a2ab7--4734a9--price",
};

module.exports = exports;
